








import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class LineTitle extends Vue {
  @Prop({ type: String, required: false, default: undefined })
  title: string | undefined;
}
